import component from './PublishModal.vue'
export default component
